<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M5.32764 20C5.32764 20.5304 5.53835 21.0391 5.91342 21.4142C6.2885 21.7893 6.7972 22 7.32764 22H17.3276C17.8581 22 18.3668 21.7893 18.7418 21.4142C19.1169 21.0391 19.3276 20.5304 19.3276 20V8H21.3276V6H17.3276V4C17.3276 3.46957 17.1169 2.96086 16.7418 2.58579C16.3668 2.21071 15.8581 2 15.3276 2H9.32764C8.7972 2 8.2885 2.21071 7.91342 2.58579C7.53835 2.96086 7.32764 3.46957 7.32764 4V6H3.32764V8H5.32764V20ZM9.32764 4H15.3276V6H9.32764V4ZM17.3276 8V20H7.32764V8H17.3276Z"
    fill="#F04738"
  />
  <path
    d="M9.32764 10H11.3276V18H9.32764V10ZM13.3276 10H15.3276V18H13.3276V10Z"
    fill="#F04738"
  />
</svg>
